module.exports = __webpack_public_path__ + "img/ProfileFA.a3bd3cd5.svg";